'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".EmailIcon-module_container__-Xv-w{height:auto;vertical-align:middle;width:2rem}";
var styles = {"container":"EmailIcon-module_container__-Xv-w"};
styleInject["default"](css_248z, '6e52ba77-7e71-4932-9cbc-6b21f5b54d50');

exports["default"] = styles;
